export default __webpack_public_path__ + "static/media/postmanBW.a65ce560.webp";